"use strict";

module.exports = {
    "user2": {
        "add-account": "Tambah akun",
        "edit-accounts": "Edit akun",
        "enter": "Masuk",
        "exit": "Keluar",
        "help": "Bantuan",
        "mail": ["pesan baru", "pesan baru", "pesan baru", "Tidak ada pesan baru"],
        "mail_compose": "Tulis pesan",
        "passport": "Manajemen akun",
        "settings": "Pengaturan",
        "upload_files": "Disk Saya"
    }
};